require('./bootstrap');
import './bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';